import { useSelector } from 'react-redux'
import { Alert } from 'antd'

import { getMaintenanceNoticeMessage } from './logic'
import { selectFlags } from './selectors'

const PlannedMaintenanceAlert = () => {
    const {
        additionalNoticeMessage,
        maintenanceNoticeDateTimeEnd,
        maintenanceNoticeDateTimeStart,
        showAdditionalNotice,
        showMaintenanceNotice,
    } = useSelector(selectFlags)

    const isAdditionalNoticeValuesSet =
        showAdditionalNotice && Boolean(additionalNoticeMessage?.length)

    const maintenanceNoticeMessage = getMaintenanceNoticeMessage(
        showMaintenanceNotice,
        maintenanceNoticeDateTimeStart,
        maintenanceNoticeDateTimeEnd,
    )

    const hasMaintenanceAndNotice =
        maintenanceNoticeMessage && isAdditionalNoticeValuesSet

    if (!showMaintenanceNotice && !isAdditionalNoticeValuesSet) {
        return null
    }

    return (
        <Alert
            closable={false}
            type="info"
            showIcon
            style={{
                width: '100%',
                border: 0,
                borderRadius: 0,
            }}
            message={
                <div style={{ paddingRight: '50px' }}>
                    {maintenanceNoticeMessage}
                    {hasMaintenanceAndNotice && <br />}
                    {isAdditionalNoticeValuesSet && additionalNoticeMessage}
                </div>
            }
        />
    )
}

export default PlannedMaintenanceAlert
